module.exports = __webpack_public_path__ + "img/create-light.bc8477ee.svg";